const routerName = {
    todolist: {
        approval: 'persetujuan',
        revise: 'revisi',
        draft: 'draft',
        cancel: 'pembatalan',
        approvalhistory: 'riwayatpersetujuan'
    }
};
export default routerName;
